import FavoritesButton from "./FavoritesButton.component";

export default FavoritesButton;
